import { useMemo } from 'react'

import { useMatches } from '@tanstack/react-router'

import { useAdminFund } from '@repo/common/queries/admin/fund'

export type FundContextResult = {
  fundId: string | null
  isInFundContext: boolean
  fundData: ReturnType<typeof useAdminFund>['data']
  isLoadingFund: boolean
  fundError: ReturnType<typeof useAdminFund>['error']
}

export const PrimaryVaultId = 'VPE'
export const PrimaryFundId = '1'

/**
 * Pulls the Fund ID from the current route if present and fetches the fund data
 */
export function useFundContext(): FundContextResult {
  const matches = useMatches()
  const currentPath =
    matches.length > 0 ? matches[matches.length - 1]!.pathname : '/'
  const fundId = useMemo(() => {
    const fundMatch = currentPath.match(/^\/fund\/([^/]+)/)
    return fundMatch?.[1] || null
  }, [currentPath])
  const isInFundContext = Boolean(fundId)
  const fundQuery = useAdminFund(fundId || '')
  return {
    fundId,
    isInFundContext,
    fundData: fundQuery.data,
    isLoadingFund: fundQuery.isLoading,
    fundError: fundQuery.error,
  }
}
